import TextField from "./TextField";

export default function BooleanField({ value }) {
  return <TextField value={value ? "Yes" : "No"} />;
}
